import Cookies from './Cookies';
export default Cookies;



//////////////////
// WEBPACK FOOTER
// ./~/universal-cookie/es6/index.js
// module id = ./node_modules/universal-cookie/es6/index.js
// module chunks = 88